import { render } from "./MapLegend.vue?vue&type=template&id=11459b80&scoped=true&ts=true"
import script from "./MapLegend.vue?vue&type=script&lang=ts"
export * from "./MapLegend.vue?vue&type=script&lang=ts"

import "./MapLegend.vue?vue&type=style&index=0&id=11459b80&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11459b80"]])

export default __exports__